// extracted by mini-css-extract-plugin
export var wrapper = "benefits-module--wrapper--LfSbW";
export var title = "benefits-module--title--igoz3";
export var btnWrapper = "benefits-module--btn-wrapper--y5sBG";